import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { getPostById } from "@/lib/blog.functions";
import { PostEditor } from "@/components/blog/PostEditor";

export const Route = createFileRoute("/_authenticated/admin/posts/$id")({
  head: () => ({ meta: [{ title: "Edit post — Admin" }, { name: "robots", content: "noindex" }] }),
  component: EditPost,
});

function EditPost() {
  const { id } = Route.useParams();
  const fetchPost = useServerFn(getPostById);
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "post", id],
    queryFn: () => fetchPost({ data: { id } }),
  });

  if (isLoading) return <p className="mt-8 text-bone/60">Loading…</p>;
  if (!data?.post) return <p className="mt-8 text-bone/60">Not found.</p>;

  return (
    <div>
      <h2 className="h-display mt-8 text-2xl text-bone">Edit post</h2>
      <PostEditor initial={data.post as any} />
    </div>
  );
}
